import React, { Component } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@conserveit/blocks";
import { $Site } from "./Site.styles";

class Site extends Component {
  static propTypes = {
    noMatch: PropTypes.bool,
    label: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    noMatch: false,
  };

  shouldComponentUpdate(prevProps) {
    return this.props.isSelected !== prevProps.isSelected;
  }

  render() {
    const { label, isSelected, handleClick, noMatch, disabled } = this.props;
    return (
      <$Site type="button" disabled={disabled} noMatch={noMatch} title={label}>
        <span className="Site-label" onClick={handleClick}>
          {label}
        </span>
        <Checkbox
          onChange={handleClick}
          checked={isSelected}
          disabled={disabled}
        />
      </$Site>
    );
  }
}

export default Site;
